import { useAuth } from "../../context/AuthContext";
import devLogger from "../../utils/devLogger";

const useFetchWithAuth = () => {
  const { refreshToken } = useAuth();

  const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
    const getAccessToken = () => localStorage.getItem("token");

    let accessToken = getAccessToken();

    const fetchOptions: RequestInit = {
      ...options,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
    };

    let response = await fetch(url, fetchOptions);

    if (response.status === 401) {
      try {
        await refreshToken();
        accessToken = getAccessToken();

        if (!accessToken) {
          throw new Error("Failed to refresh token.");
        }

        fetchOptions.headers = {
          ...fetchOptions.headers,
          Authorization: `Bearer ${accessToken}`,
        };

        response = await fetch(url, fetchOptions);
      } catch (error) {
        devLogger.error("Token refresh failed:", error);
        throw new Error("Session expired. Please log in again.");
      }
    }

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    try {
      return await response.json();
    } catch (error) {
      console.warn("Failed to parse JSON response:", error);
      return response;
    }
  };

  return { fetchWithAuth };
};

export default useFetchWithAuth;
